import * as React from 'react'
function SvgCard(props) {
	return (
		<svg
			width="1em"
			height="1em"
			viewBox="0 0 40 40"
			xmlns="http://www.w3.org/2000/svg"
			{...props}
		>
			<g fill="currentColor" fillRule="evenodd">
				<path d="M36 14v-4c0-1.2-.8-2-2-2H6c-1.2 0-2 .8-2 2v4h32zM4 18v12c0 1.2.8 2 2 2h28c1.2 0 2-.8 2-2V18H4zm12 8H8v-2h8v2zm16 0h-4v-2h4v2z" />
			</g>
		</svg>
	)
}
export default SvgCard
